import "./bootstrap";
import Lightbox from "bs5-lightbox";
import { Tooltip, Popover } from "bootstrap";
// import ScrollMagic from "scrollmagic";

function initPopovers() {
    const popovers = document.querySelectorAll("[data-bs-toggle='popover']");
    let activePopover = null;
    let activeElement = null;

    popovers.forEach((el) => {
        const popover = new Popover(el, {
            html: true,
            trigger: "manual", // Important pour contrôle manuel
        });

        el.addEventListener("click", (e) => {
            e.stopPropagation();

            // Si autre popover actif, on le ferme
            if (activePopover && activePopover !== popover) {
                activePopover.hide();
            }

            if (activePopover === popover) {
                popover.hide();
                activePopover = null;
                activeElement = null;
            } else {
                popover.show();
                activePopover = popover;
                activeElement = el;
            }
        });
    });

    // Clic en dehors => ferme le popover sauf si on clique DANS le popover
    document.addEventListener("click", (event) => {
        const popoverEl = document.querySelector(".popover"); // Popover visible

        if (
            activePopover &&
            !popoverEl?.contains(event.target) &&
            !activeElement?.contains(event.target)
        ) {
            activePopover.hide();
            activePopover = null;
            activeElement = null;
        }
    });
}

ready(function () {
    console.log("Your app is ready! Add your initialization functions below.");

    initTooltips();
    initPopovers();
    initLightbox();
});

function initTooltips() {
    console.log("Initializing tooltips...");

    const tooltipTriggerList = document.querySelectorAll(
        '[data-bs-toggle="tooltip"]'
    );
    [...tooltipTriggerList].map(
        (tooltipTriggerEl) => new Tooltip(tooltipTriggerEl)
    );
}

function initLightbox() {
    console.log("Initializing Lightbox...");

    const options = {
        keyboard: true,
        size: "xl",
    };

    document.querySelectorAll(".lightbox").forEach((el) =>
        el.addEventListener("click", function () {
            const lightbox = new Lightbox(el, options);
            lightbox.show();
        })
    );
}

function ready(fn) {
    if (document.readyState !== "loading") {
        fn();
        return;
    }
    document.addEventListener("DOMContentLoaded", fn);
}
